<template>
  <div class="page_win resigetWin">
    <div class="topContent">
      <div class="topContent_l" @click="back">
        <img :src="returnRightImg" alt="" />
      </div>
      <div class="topContent_m">
        <span>账号注册</span>
      </div>
    </div>
    <div class="bottomContent">
      <div class="view_group">
        <div class="view_group_l">
          <img :src="userImg" class="account_icon" alt="" />
          <input
            placeholder-style="color:#999"
            type="text"
            name="uname"
            v-model="uname"
            placeholder="请输入账号"
            autocomplete="off"
          />
        </div>
        <div class="view_group_r" @click="uname=''">
            <img :src="close_icon2" alt="" />
          </div>
      </div>

      <div class="view_group">
        <div class="view_group_l">
          <img :src="passImg" class="pwd_icon" alt="" />
          <input
            placeholder-style="color:#999"
            maxlength="10"
            type="password"
            name="pwd"
            v-model="pwd"
            placeholder="请输入密码"
            autocomplete="off"
          />
        </div>
        <div class="view_group_r" @click="pwd=''">
            <img :src="close_icon2" alt="" />
          </div>
      </div>
    </div> 
    
    <!-- <div class="register">
      <div @click="freeLogin">游客登录</div>
      </div> -->

    <div class="bot_btn" @click="registAcount">快速注册</div>
    <div class="botBox">
      <div class="userRule">
        <div class="userRule_l" @click="isCheched = !isCheched">
          <img :src="checkRule" alt="" v-if="isCheched" />
        </div>
        <div class="userRule_r">
          <span>&nbsp;我已阅读并同意</span>
          <a @click="isShowAgreement = true;ruleType='agr'">用户协议</a><span>及</span><a @click="isShowAgreement = true;ruleType='pri'">隐私政策</a>
        </div>
      </div>
    </div>
    <div class="tipWin" v-if="$store.state.winType.isAgreementTip">
      <agreementTip />
    </div>
    <div class="agrBox" v-if="isShowAgreement" >
      <agreement class="agrCon" :type='ruleType' />
      <div class="closeAgr" @click="isShowAgreement = false;ruleType=''"><img :src="closeImg" alt=""></div>
    </div>
  </div>
</template>

<script>
import { hex_md5 } from "@/common/js/md5.js";
import fun from "@/common/js/common.js";
import agreement from '../../components/agreement.vue';
import agreementTip from "./agreementTip";

export default {
  components: { agreement ,agreementTip},
  name: "register",
  inject: ["reload"], //注入App里的reload方法
  data() {
    return {
      userInfo: {}, //用户资料
      adid: "", // 广告id
      uname: "",
      pwd: "",
      returnRightImg: require("../../assets/img/new2/back.png"), // 关闭
      userImg: require("../../assets/img/view6/account.png"),
      passImg: require("../../assets/img/view6/pwd.png"),
      checkRule: require("../../assets/img/view6/select.png"),
      close_icon2: require("../../assets/img/view6/close2.png"),
      isCheched: false,
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
      isShowAgreement:false,
      ruleType:'agr'
    };
  },
  created() {},
  mounted() {

    
   


    this.userInfo =
      localStorage.getItem("userInfo") &&
      localStorage.getItem("userInfo") != "undefined"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");
      this.getFastreg()
  },
  methods: {
    getFastreg(){
      this.$http.get(fun.apiUrl +  "api/member/fastreg").then(
        function (res) {
          console.log(res);
          if (res.body.code === 200) {
             this.uname = res.body.data.uname;
              this.pwd =res.body.data.pwd;
          }
        },
        function (res) {}
      );
      
    },
    back() {
      this.$store.dispatch("IsRegisterFun", false);
      this.$store.dispatch("IsLoginBoxFun", true);
    },
    // 注册账号(用户名注册)
    registAcount() {
      if (!this.isCheched) {
        this.$store.dispatch("IsAgreementTipFun", true);
        return false;
      }else if (!this.uname) {
        this.$toast.text("请输入用户名");
        return false;
      }else if (!this.pwd) {
        this.$toast.text("请输入密码");
        return false;
      }else if (this.isCommit) {
        // 说明当前有请求正在提交了，避免重复提交
        return;
      }
      // 如果没有提交，则修改提交状态, 后续的请求不可以再提交
      this.isCommit = true;
      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + time
      );
      var device_params = this.$store.state.deviceData;
      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: device_params.os,
        uname: this.uname,
        pwd: this.pwd,
        device_params: device_params,
        reg_type: "1", //1：用户名注册，2：随机注册，3：短信登录,0:为游客登录
      };

      this.$http.post(fun.apiUrl + "api/member/reg", data).then(
        function (res) {
          this.isCommit = false;
          if (res.body.code === 200) {
            localStorage.setItem("isOldReg", this.adid);
            this.$toast.text(res.body.msg);
            localStorage.setItem("userInfo", JSON.stringify(res.body.data));
            this.$store.dispatch("IsRegisterFun", false);
            this.userInfo = res.body.data;
            this.$store.commit("postRegisterPwd", this.pwd);
            this.$store.dispatch("IsAccountAndPasFun", true);
            let _this = this;
            let msg = {
               uname: this.uname,
                pwd: this.pwd,
            }
            localStorage.setItem("userLoginMsg",JSON.stringify(msg));
            setTimeout(function () {
              _this.$store.dispatch("IsAccountAndPasFun", false);
              _this.reload();
              /*******只登录跳转认证提示，认证页面******* */
              if (res.body.data.loginFcm == 2 && res.body.data.fcm != "1") {
                setTimeout(function () {
                  _this.$store.dispatch("IsReconiseInfoFun", true);
                }, 1000);
              }
            }, 5000);
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {
          // 请求完成，修改防止重复提交标识，让其他请求可以提交
          this.isCommit = false;
        }
      );
    },
    // 游客登录
    freeLogin() {
      if (!this.isCheched) {
        this.$store.dispatch("IsAgreementTipFun", true);
        return false;
      }
      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + +this.adid + time
      );
      var device_params = this.$store.state.deviceData;

      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: this.$store.state.deviceData.os,
        device_params: device_params,

        reg_type: "0",
      };
      this.$http.post(fun.apiUrl + "api/member/tourist", data).then(
        function (res) {
          if (res.body.code === 200) {
            let msg = {
               uname:res.body.data.uname,
                pwd: res.body.data.pwd,
            }
            localStorage.setItem("userLoginMsg",JSON.stringify(msg));
            localStorage.setItem("isOldReg", this.adid);
            this.$toast.text(res.body.msg);
            localStorage.setItem("userInfo", JSON.stringify(res.body.data));
            this.$store.dispatch("IsRegisterFun", false);
            this.$store.commit("postRegisterPwd", res.body.data.pwd);
            this.$store.dispatch("IsAccountAndPasFun", true);
            let _this = this;
            setTimeout(function () {
              _this.$store.dispatch("IsAccountAndPasFun", false);
              _this.reload();
            }, 5000);
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {}
      );
    },
  },
};
</script>

<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}
::-webkit-input-placeholder {
  color: #bcbcbc;
}
::-moz-placeholder {
  color: #bcbcbc;
}
:-ms-input-placeholder {
  color: #bcbcbc;
}
input:-moz-placeholder {
  color: #bcbcbc;
}
.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
}
.topContent_l,
.topContent_m {
  @include flex_box(row, center, center);
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #FF913A;
    line-height: 0.68rem;
  }
}
.topContent_l {
  position: absolute;
  top: 0;
  left: 0;
  height: 0.68rem;
  width: 0.8rem;
  justify-content: flex-start;
  img {
    width: 0.24rem;
    height: auto;
  }
}

.bottomContent {
  @include flex_box(column, none, stretch);
}
.view_group {
  position: relative;
  padding: 0 0.22rem;
  border-radius: 0.1rem;
  margin-top: 0.24rem;
  height: 0.82rem;
  @include flex_box(row, space-between, center);
  border: 1px solid #FF913A;
}
.register {
  margin-top: 0.14rem;
  height: 0.3rem;
  @include flex_box(row, space-between, stretch);
  div {
    @include flex_box(row, center, center);
    flex: 1;
    font-size: 0.24rem;
    color: #ff913a;
  }
}
.botBox {
  height: .6rem;
  @include flex_box(row, space-between, stretch);
}
.botBox_l {
  @include flex_box(row, none, center);
  font-size: 0.22rem;
}
.userRule {
  @include flex_box(row, space-between, center);
  font-size: 14px;
}
.userRule_l {
  @include flex_box(row, center, center);
  width: 0.32rem;
  height: 0.32rem;
  background-size: 100% 100%;
  border: 1px solid #ff913a;
  border-radius: 50%;
  img {
    width: 0.2rem;
    height: auto;
  }
}
.userRule_r {
  @include flex_box(row, none, center);
  vertical-align: middle;
  span {
    color: #a6a5ad;
  }
  a {
    text-decoration: none;
    color: #FF913A;
  }
}
.tipWin {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  @include flex_box(row, center, center);
}
.agrBox{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.agrCon{
  width: 100%;
  height: 100%;
}
.closeAgr{
  position: absolute;
  right: 0;
  top: 0;
  width: .6rem;
  height: .6rem;
  @include flex_box(row, center, center);
  img{
    width: .3rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/view8/register.vue